import {isEmpty, isNil, isNotNil, keys} from 'ramda';

import {getSafely, Nullish} from 'shared/web';

import {DrillDownLevel, DrillDownLevelName} from '../../../../../types/api/drillDown';

export function getPermanentLevelFilters(
  permanentFilters: Partial<Record<DrillDownLevelName, string>> | Nullish
): DrillDownLevel[] {
  if (isNil(permanentFilters) || isEmpty(permanentFilters)) {
    return [];
  }

  return keys(permanentFilters)
    .filter((levelName) => isNotNil(getSafely(permanentFilters, levelName)))
    .map((levelName, index) => ({
      level: levelName,
      values: [getSafely(permanentFilters, levelName)!],
      priority: index + 1,
    }));
}
